import React, { useState } from "react";
import styles from "./DanceGallery.module.css";
import { X } from 'lucide-react';

const DancePhotosGallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const images = [
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_3.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_4.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_5.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_6.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_7.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_8.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_9.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_11.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_12.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_13.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_14.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_15.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_16.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_17.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_18.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_19.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_20.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_21.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_23.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_24.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_25.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_26.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_28.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_29.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_31.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_32.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_33.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_34.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_35.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_36.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_37.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_38.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_39.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_40.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_42.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_43.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_44.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_46.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_47.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_49.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_50.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_54.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_58.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_59.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_60.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_61.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_62.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_63.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_64.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_66.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_67.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_68.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_69.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_71.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_73.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_74.jpeg",
    "/assets/imgs/gallery/dance_pics/nupur_dance_pics_76.jpeg",
  ];

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Dance Performance Gallery</h1>
        <p>Moments of artistry, passion, and achievement from our students and instructors</p>
      </header>

      <div className={styles.galleryGrid}>
        {images.map((src, index) => (
          <div
            key={index}
            className={styles.imageWrapper}
            onClick={() => setSelectedImage(src)}
          >
            <img src={src} alt="Dance Performance" />
            <div className={styles.overlay}>
              <span>View Full Size</span>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className={styles.lightbox} onClick={() => setSelectedImage(null)}>
          <button
            className={styles.closeBtn}
            onClick={() => setSelectedImage(null)}
          >
            <X size={40} color="white" />
          </button>
          <img
            src={selectedImage}
            className={styles.fullImage}
            alt="Full size"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default DancePhotosGallery;
